import { Award, ShieldCheck } from "lucide-react";

export default function TrustStrip() {
  const clients = [
    "MakeMyTrip",
    "Sri Chaitanya",
    "Tridasa",
    "Bridge Group",
    "Canduer",
  ];

  return (
    <section className="py-10 bg-[#F8FAFC] border-b border-slate-200/80">
      <div className="w-full max-w-[1200px] mx-auto px-8 relative z-10">
        <div className="space-y-5">
          {/* Top Pill Badges */}
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
            <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white border border-slate-200 shadow-sm text-xs sm:text-sm font-medium text-slate-800">
              <Award className="w-4 h-4 text-[#F2A339] shrink-0" />
              <span>Google for Startups at T-Hub, Hyderabad</span>
            </div>

            <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white border border-slate-200 shadow-sm text-xs sm:text-sm font-medium text-slate-800">
              <ShieldCheck className="w-4 h-4 text-[#F2A339] shrink-0" />
              <span>Math Nuage, supported by DST, Government of India</span>
            </div>
          </div>

          {/* Client Logos / Names */}
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 pt-2">
            <span className="text-xs sm:text-sm font-medium text-slate-400">
              Trusted by teams at
            </span>

            <div className="flex flex-wrap items-center gap-x-8 gap-y-2">
              {clients.map((client, idx) => (
                <span
                  key={idx}
                  className="text-sm sm:text-base font-semibold text-slate-700 hover:text-slate-950 transition-colors"
                >
                  {client}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
